var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsMobileVd(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4568.89 7034.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:lime;}.cls-2{fill:#00e767;}.cls-3{fill:#ccc;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "851.15 2105.88 851.15 2142.87 555.24 2142.87 555.24 331.44 1924.26 331.44 1924.26 367.43 1996.71 367.43 1996.71 2105.88 851.15 2105.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2645.18 2059.09 2645.19 2096.07 2386.27 2096.07 2386.27 321.63 3643.48 321.14 3644.25 537.56 3828.5 538.05 3827.75 2059.09 2645.18 2059.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1775.2 4414.51 1775.2 4451.51 554.59 4451.51 554.59 2825.02 1886.62 2825.02 1886.62 2899.68 1996.06 2899.68 1996.06 4414.51 1775.2 4414.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2028.82 6732.3 587.35 6732.3 587.35 5291.5 1808.13 5291.51 1807.79 5438.46 1956.37 5438.46 1956.37 5475.45 2028.49 5475.45 2028.82 6732.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3805.11 4373 3805.11 4631.92 2399.1 4631.92 2399.1 2820.5 3692.32 2820 3693.08 2967.93 3841.33 2968.43 3840.57 4373 3805.11 4373"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1958.46,
    y: 293.44,
    width: 72.45,
    height: 35.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3697.95,
    y: 271.95,
    width: 182.65,
    height: 220.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1933.98,
    y: 2786.93,
    width: 112.1,
    height: 71.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2004.65 5392.72 2004.65 5429.71 2076.77 5429.71 2076.77 5246.14 1856.36 5246.14 1856.36 5392.72 2004.65 5392.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3743.71,
    y: 2771.66,
    width: 142.93,
    height: 148.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1961.24,
    y1: 367.43,
    x2: 1961.25,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1924.26,
    y1: 331.44,
    x2: 1924.26,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1887.27,
    y1: 331.44,
    x2: 1887.27,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1849.82,
    y1: 331.45,
    x2: 1849.83,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1812.84,
    y1: 331.45,
    x2: 1812.84,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1775.85,
    y1: 331.45,
    x2: 1775.85,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1738.86,
    y1: 331.45,
    x2: 1738.86,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1701.87,
    y1: 331.45,
    x2: 1701.87,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1664.88,
    y1: 331.45,
    x2: 1664.89,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1627.89,
    y1: 331.45,
    x2: 1627.9,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1590.91,
    y1: 331.45,
    x2: 1590.91,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1553.92,
    y1: 331.45,
    x2: 1553.92,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1516.93,
    y1: 331.45,
    x2: 1516.93,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1479.94,
    y1: 331.45,
    x2: 1479.94,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1442.95,
    y1: 331.45,
    x2: 1442.96,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1405.97,
    y1: 331.45,
    x2: 1405.97,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1368.98,
    y1: 331.45,
    x2: 1368.98,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1331.99,
    y1: 331.45,
    x2: 1331.99,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1295,
    y1: 331.45,
    x2: 1295,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1258.01,
    y1: 331.45,
    x2: 1258.02,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1221.03,
    y1: 331.45,
    x2: 1221.03,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1184.04,
    y1: 331.45,
    x2: 1184.04,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1147.05,
    y1: 331.45,
    x2: 1147.05,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1110.06,
    y1: 331.45,
    x2: 1110.06,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1073.07,
    y1: 331.45,
    x2: 1073.08,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1036.08,
    y1: 331.45,
    x2: 1036.09,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 999.1,
    y1: 331.45,
    x2: 999.1,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 962.11,
    y1: 331.45,
    x2: 962.11,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.12,
    y1: 331.45,
    x2: 925.12,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 888.13,
    y1: 331.45,
    x2: 888.13,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 851.14,
    y1: 331.45,
    x2: 851.15,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 814.16,
    y1: 331.45,
    x2: 814.16,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 777.17,
    y1: 331.45,
    x2: 777.17,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 740.18,
    y1: 331.45,
    x2: 740.18,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 703.19,
    y1: 331.45,
    x2: 703.19,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.2,
    y1: 331.45,
    x2: 666.21,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 629.21,
    y1: 331.45,
    x2: 629.22,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 592.23,
    y1: 331.45,
    x2: 592.23,
    y2: 2142.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 367.43,
    x2: 1998.23,
    y2: 367.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 404.42,
    x2: 1998.23,
    y2: 404.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 441.41,
    x2: 1998.23,
    y2: 441.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 478.4,
    x2: 1998.23,
    y2: 478.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 515.39,
    x2: 1998.23,
    y2: 515.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 552.37,
    x2: 1998.23,
    y2: 552.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 589.36,
    x2: 1998.23,
    y2: 589.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 626.35,
    x2: 1998.23,
    y2: 626.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 663.34,
    x2: 1998.23,
    y2: 663.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 700.33,
    x2: 1998.23,
    y2: 700.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 737.32,
    x2: 1998.23,
    y2: 737.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 774.3,
    x2: 1998.23,
    y2: 774.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 811.29,
    x2: 1998.23,
    y2: 811.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 848.28,
    x2: 1998.23,
    y2: 848.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 885.27,
    x2: 1998.23,
    y2: 885.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 922.26,
    x2: 1998.23,
    y2: 922.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 959.24,
    x2: 1998.23,
    y2: 959.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 996.23,
    x2: 1998.23,
    y2: 996.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1033.22,
    x2: 1998.23,
    y2: 1033.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1070.21,
    x2: 1998.23,
    y2: 1070.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1107.2,
    x2: 1998.23,
    y2: 1107.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1144.18,
    x2: 1998.23,
    y2: 1144.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1181.17,
    x2: 1998.23,
    y2: 1181.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1218.16,
    x2: 1998.23,
    y2: 1218.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1255.15,
    x2: 1998.23,
    y2: 1255.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1292.14,
    x2: 1998.23,
    y2: 1292.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1329.13,
    x2: 1998.23,
    y2: 1329.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1366.11,
    x2: 1998.23,
    y2: 1366.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1403.1,
    x2: 1998.23,
    y2: 1403.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1440.09,
    x2: 1998.23,
    y2: 1440.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1477.08,
    x2: 1998.23,
    y2: 1477.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1514.07,
    x2: 1998.23,
    y2: 1514.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1551.05,
    x2: 1998.23,
    y2: 1551.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1588.04,
    x2: 1998.23,
    y2: 1588.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1625.03,
    x2: 1998.23,
    y2: 1625.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1662.02,
    x2: 1998.23,
    y2: 1662.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1699.01,
    x2: 1998.23,
    y2: 1699.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1736,
    x2: 1998.23,
    y2: 1736
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1772.98,
    x2: 1998.23,
    y2: 1772.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1809.97,
    x2: 1998.23,
    y2: 1809.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1846.96,
    x2: 1998.23,
    y2: 1846.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1883.95,
    x2: 1998.23,
    y2: 1883.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1920.94,
    x2: 1998.23,
    y2: 1920.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1957.92,
    x2: 1998.23,
    y2: 1957.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 1994.91,
    x2: 1998.23,
    y2: 1994.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 2031.9,
    x2: 1998.23,
    y2: 2031.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 2068.89,
    x2: 1998.23,
    y2: 2068.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 555.24,
    y1: 2105.88,
    x2: 1998.23,
    y2: 2105.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1994.68,
    y1: 293.06,
    x2: 1994.68,
    y2: 329.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3792.27,
    y1: 538.06,
    x2: 3792.27,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3755.28,
    y1: 538.06,
    x2: 3755.29,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3718.3,
    y1: 538.06,
    x2: 3718.3,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3680.85,
    y1: 538.06,
    x2: 3680.85,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3643.86,
    y1: 321.64,
    x2: 3643.87,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3606.88,
    y1: 321.64,
    x2: 3606.88,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3569.89,
    y1: 321.64,
    x2: 3569.89,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3532.9,
    y1: 321.64,
    x2: 3532.9,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3495.91,
    y1: 321.64,
    x2: 3495.91,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3458.92,
    y1: 321.64,
    x2: 3458.93,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3421.93,
    y1: 321.64,
    x2: 3421.94,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3384.95,
    y1: 321.64,
    x2: 3384.95,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3347.96,
    y1: 321.64,
    x2: 3347.96,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3310.97,
    y1: 321.64,
    x2: 3310.97,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3273.98,
    y1: 321.64,
    x2: 3273.98,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3236.99,
    y1: 321.64,
    x2: 3237,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3200.01,
    y1: 321.64,
    x2: 3200.01,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3163.02,
    y1: 321.64,
    x2: 3163.02,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3126.03,
    y1: 321.64,
    x2: 3126.03,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3089.04,
    y1: 321.64,
    x2: 3089.04,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3052.05,
    y1: 321.64,
    x2: 3052.06,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3015.06,
    y1: 321.64,
    x2: 3015.07,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2978.08,
    y1: 321.64,
    x2: 2978.08,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2941.09,
    y1: 321.64,
    x2: 2941.09,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2904.1,
    y1: 321.64,
    x2: 2904.1,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2867.11,
    y1: 321.64,
    x2: 2867.11,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2830.12,
    y1: 321.64,
    x2: 2830.13,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2793.14,
    y1: 321.64,
    x2: 2793.14,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2756.15,
    y1: 321.64,
    x2: 2756.15,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2719.16,
    y1: 321.64,
    x2: 2719.16,
    y2: 2061.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2682.17,
    y1: 321.64,
    x2: 2682.17,
    y2: 2061.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2645.18,
    y1: 321.64,
    x2: 2645.19,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2608.19,
    y1: 321.64,
    x2: 2608.2,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2571.21,
    y1: 321.64,
    x2: 2571.21,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2534.22,
    y1: 321.64,
    x2: 2534.22,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2497.23,
    y1: 321.64,
    x2: 2497.23,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2460.24,
    y1: 321.64,
    x2: 2460.24,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2423.25,
    y1: 321.64,
    x2: 2423.26,
    y2: 2096.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 357.63,
    x2: 3643.86,
    y2: 357.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 394.62,
    x2: 3643.86,
    y2: 394.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 431.61,
    x2: 3643.86,
    y2: 431.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 468.6,
    x2: 3643.86,
    y2: 468.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 505.58,
    x2: 3643.86,
    y2: 505.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 542.57,
    x2: 3829.26,
    y2: 542.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 579.56,
    x2: 3829.26,
    y2: 579.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 616.55,
    x2: 3829.26,
    y2: 616.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 653.54,
    x2: 3829.26,
    y2: 653.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 690.52,
    x2: 3829.26,
    y2: 690.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 727.51,
    x2: 3829.26,
    y2: 727.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 764.5,
    x2: 3829.26,
    y2: 764.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 801.49,
    x2: 3829.26,
    y2: 801.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 838.48,
    x2: 3829.26,
    y2: 838.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 875.47,
    x2: 3829.26,
    y2: 875.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 912.45,
    x2: 3829.26,
    y2: 912.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 949.44,
    x2: 3829.26,
    y2: 949.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 986.43,
    x2: 3829.26,
    y2: 986.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1023.42,
    x2: 3829.26,
    y2: 1023.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1060.41,
    x2: 3829.26,
    y2: 1060.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1097.39,
    x2: 3829.26,
    y2: 1097.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1134.38,
    x2: 3829.26,
    y2: 1134.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1171.37,
    x2: 3829.26,
    y2: 1171.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1208.36,
    x2: 3829.26,
    y2: 1208.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1245.35,
    x2: 3829.26,
    y2: 1245.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1282.34,
    x2: 3829.26,
    y2: 1282.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1319.32,
    x2: 3829.26,
    y2: 1319.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1356.31,
    x2: 3829.26,
    y2: 1356.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1393.3,
    x2: 3829.26,
    y2: 1393.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1430.29,
    x2: 3829.26,
    y2: 1430.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1467.28,
    x2: 3829.26,
    y2: 1467.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1504.26,
    x2: 3829.26,
    y2: 1504.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1541.25,
    x2: 3829.26,
    y2: 1541.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1578.24,
    x2: 3829.26,
    y2: 1578.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1615.23,
    x2: 3829.26,
    y2: 1615.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1652.22,
    x2: 3829.26,
    y2: 1652.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1689.2,
    x2: 3829.26,
    y2: 1689.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1726.19,
    x2: 3829.26,
    y2: 1726.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1763.18,
    x2: 3829.26,
    y2: 1763.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1800.17,
    x2: 3829.26,
    y2: 1800.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1837.16,
    x2: 3829.26,
    y2: 1837.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1874.15,
    x2: 3829.26,
    y2: 1874.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1911.13,
    x2: 3829.26,
    y2: 1911.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1948.12,
    x2: 3828.5,
    y2: 1948.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 1985.11,
    x2: 3828.5,
    y2: 1985.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 2022.1,
    x2: 3828.5,
    y2: 2022.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2386.27,
    y1: 2059.09,
    x2: 3827.75,
    y2: 2059.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3734.71,
    y1: 271.95,
    x2: 3734.71,
    y2: 492.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3771.29,
    y1: 271.95,
    x2: 3771.29,
    y2: 492.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3806.87,
    y1: 271.95,
    x2: 3806.87,
    y2: 492.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3843.44,
    y1: 271.95,
    x2: 3843.44,
    y2: 492.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1960.6,
    y1: 2893.66,
    x2: 1960.6,
    y2: 4414.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1923.61,
    y1: 2898.92,
    x2: 1923.61,
    y2: 4414.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1886.62,
    y1: 2825.02,
    x2: 1886.62,
    y2: 4414.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1849.18,
    y1: 2825.02,
    x2: 1849.18,
    y2: 4414.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1812.19,
    y1: 2825.02,
    x2: 1812.19,
    y2: 4414.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1775.2,
    y1: 2825.02,
    x2: 1775.2,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1738.21,
    y1: 2825.02,
    x2: 1738.21,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1701.22,
    y1: 2825.02,
    x2: 1701.23,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1664.24,
    y1: 2825.02,
    x2: 1664.24,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1627.25,
    y1: 2825.02,
    x2: 1627.25,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1590.26,
    y1: 2825.02,
    x2: 1590.26,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1553.27,
    y1: 2825.02,
    x2: 1553.27,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1516.28,
    y1: 2825.02,
    x2: 1516.29,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1479.29,
    y1: 2825.02,
    x2: 1479.3,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1442.31,
    y1: 2825.02,
    x2: 1442.31,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1405.32,
    y1: 2825.02,
    x2: 1405.32,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1368.33,
    y1: 2825.02,
    x2: 1368.33,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1331.34,
    y1: 2825.02,
    x2: 1331.34,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1294.35,
    y1: 2825.02,
    x2: 1294.36,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1257.37,
    y1: 2825.02,
    x2: 1257.37,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1220.38,
    y1: 2825.02,
    x2: 1220.38,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.39,
    y1: 2825.02,
    x2: 1183.39,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.4,
    y1: 2825.02,
    x2: 1146.4,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1109.41,
    y1: 2825.02,
    x2: 1109.42,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1072.42,
    y1: 2825.02,
    x2: 1072.43,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1035.44,
    y1: 2825.02,
    x2: 1035.44,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 998.45,
    y1: 2825.02,
    x2: 998.45,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 961.46,
    y1: 2825.02,
    x2: 961.46,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 924.47,
    y1: 2825.02,
    x2: 924.47,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 887.48,
    y1: 2825.02,
    x2: 887.49,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.5,
    y1: 2825.02,
    x2: 850.5,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.51,
    y1: 2825.02,
    x2: 813.51,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 776.52,
    y1: 2825.02,
    x2: 776.52,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 739.53,
    y1: 2825.02,
    x2: 739.53,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 702.54,
    y1: 2825.02,
    x2: 702.55,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 665.55,
    y1: 2825.02,
    x2: 665.56,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 628.57,
    y1: 2825.02,
    x2: 628.57,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 591.58,
    y1: 2825.02,
    x2: 591.58,
    y2: 4451.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 2861.01,
    x2: 1884.53,
    y2: 2861.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 2898,
    x2: 1884.53,
    y2: 2898
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 2934.99,
    x2: 1997.59,
    y2: 2934.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 2971.97,
    x2: 1997.59,
    y2: 2971.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3008.96,
    x2: 1997.59,
    y2: 3008.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3045.95,
    x2: 1997.59,
    y2: 3045.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3082.94,
    x2: 1997.59,
    y2: 3082.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3119.93,
    x2: 1997.59,
    y2: 3119.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3156.92,
    x2: 1997.59,
    y2: 3156.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3193.9,
    x2: 1997.59,
    y2: 3193.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3230.89,
    x2: 1997.59,
    y2: 3230.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3267.88,
    x2: 1997.59,
    y2: 3267.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3304.87,
    x2: 1997.59,
    y2: 3304.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3341.86,
    x2: 1997.59,
    y2: 3341.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3378.84,
    x2: 1997.59,
    y2: 3378.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3415.83,
    x2: 1997.59,
    y2: 3415.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3452.82,
    x2: 1997.59,
    y2: 3452.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3489.81,
    x2: 1997.59,
    y2: 3489.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3526.8,
    x2: 1997.59,
    y2: 3526.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3563.79,
    x2: 1997.59,
    y2: 3563.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3600.77,
    x2: 1997.59,
    y2: 3600.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3637.76,
    x2: 1997.59,
    y2: 3637.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3674.75,
    x2: 1997.59,
    y2: 3674.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3711.74,
    x2: 1997.59,
    y2: 3711.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3748.73,
    x2: 1997.59,
    y2: 3748.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3785.71,
    x2: 1997.59,
    y2: 3785.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3822.7,
    x2: 1997.59,
    y2: 3822.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3859.69,
    x2: 1997.59,
    y2: 3859.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3896.68,
    x2: 1997.59,
    y2: 3896.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3933.67,
    x2: 1997.59,
    y2: 3933.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 3970.66,
    x2: 1997.59,
    y2: 3970.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4007.64,
    x2: 1997.59,
    y2: 4007.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4044.63,
    x2: 1997.59,
    y2: 4044.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4081.62,
    x2: 1997.59,
    y2: 4081.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4118.61,
    x2: 1997.59,
    y2: 4118.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4155.6,
    x2: 1997.59,
    y2: 4155.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4192.58,
    x2: 1997.59,
    y2: 4192.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4229.57,
    x2: 1997.59,
    y2: 4229.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4266.56,
    x2: 1997.59,
    y2: 4266.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4303.55,
    x2: 1997.59,
    y2: 4303.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.59,
    y1: 4340.54,
    x2: 1997.59,
    y2: 4340.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 553.32,
    y1: 4377.53,
    x2: 1996.31,
    y2: 4377.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 553.32,
    y1: 4414.51,
    x2: 1996.31,
    y2: 4414.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1971.54,
    y1: 2786.93,
    x2: 1971.54,
    y2: 2861.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2009.09,
    y1: 2786.93,
    x2: 2009.09,
    y2: 2861.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1993.36,
    y1: 5475.45,
    x2: 1993.36,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1956.37,
    y1: 5438.46,
    x2: 1956.37,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1919.38,
    y1: 5438.46,
    x2: 1919.38,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1881.93,
    y1: 5438.46,
    x2: 1881.94,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1844.95,
    y1: 5438.46,
    x2: 1844.95,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1807.96,
    y1: 5291.51,
    x2: 1807.96,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1770.97,
    y1: 5291.51,
    x2: 1770.97,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1733.98,
    y1: 5291.51,
    x2: 1733.98,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1696.99,
    y1: 5291.51,
    x2: 1697,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1660.01,
    y1: 5291.51,
    x2: 1660.01,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1623.02,
    y1: 5291.51,
    x2: 1623.02,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1586.03,
    y1: 5291.51,
    x2: 1586.03,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1549.04,
    y1: 5291.51,
    x2: 1549.04,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1512.05,
    y1: 5291.51,
    x2: 1512.06,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1475.06,
    y1: 5291.51,
    x2: 1475.07,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1438.08,
    y1: 5291.51,
    x2: 1438.08,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1401.09,
    y1: 5291.51,
    x2: 1401.09,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1364.1,
    y1: 5291.51,
    x2: 1364.1,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1327.11,
    y1: 5291.51,
    x2: 1327.11,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1290.12,
    y1: 5291.51,
    x2: 1290.13,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1253.14,
    y1: 5291.51,
    x2: 1253.14,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1216.15,
    y1: 5291.51,
    x2: 1216.15,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1179.16,
    y1: 5291.51,
    x2: 1179.16,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1142.17,
    y1: 5291.51,
    x2: 1142.17,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1105.18,
    y1: 5291.51,
    x2: 1105.19,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1068.2,
    y1: 5291.51,
    x2: 1068.2,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1031.21,
    y1: 5291.51,
    x2: 1031.21,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 994.22,
    y1: 5291.51,
    x2: 994.22,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 957.23,
    y1: 5291.51,
    x2: 957.23,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 920.24,
    y1: 5291.51,
    x2: 920.25,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 883.25,
    y1: 5291.51,
    x2: 883.26,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 846.27,
    y1: 5291.51,
    x2: 846.27,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 809.28,
    y1: 5291.51,
    x2: 809.28,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 772.29,
    y1: 5291.51,
    x2: 772.29,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 735.3,
    y1: 5291.51,
    x2: 735.3,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 698.31,
    y1: 5291.51,
    x2: 698.32,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 661.33,
    y1: 5291.51,
    x2: 661.33,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 624.34,
    y1: 5291.51,
    x2: 624.34,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5291.51,
    x2: 587.35,
    y2: 6732.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5327.5,
    x2: 1807.31,
    y2: 5327.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5364.49,
    x2: 1807.31,
    y2: 5364.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5401.47,
    x2: 1807.31,
    y2: 5401.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5438.46,
    x2: 2030.34,
    y2: 5438.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5475.45,
    x2: 2030.34,
    y2: 5475.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5512.44,
    x2: 2030.34,
    y2: 5512.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5549.43,
    x2: 2030.34,
    y2: 5549.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5586.42,
    x2: 2030.34,
    y2: 5586.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5623.4,
    x2: 2030.34,
    y2: 5623.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5660.39,
    x2: 2030.34,
    y2: 5660.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5697.38,
    x2: 2030.34,
    y2: 5697.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5734.37,
    x2: 2030.34,
    y2: 5734.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5771.36,
    x2: 2030.34,
    y2: 5771.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5808.34,
    x2: 2030.34,
    y2: 5808.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5845.33,
    x2: 2030.34,
    y2: 5845.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5882.32,
    x2: 2030.34,
    y2: 5882.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5919.31,
    x2: 2030.34,
    y2: 5919.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5956.3,
    x2: 2030.34,
    y2: 5956.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 5993.29,
    x2: 2030.34,
    y2: 5993.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6030.27,
    x2: 2030.34,
    y2: 6030.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6067.26,
    x2: 2030.34,
    y2: 6067.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6104.25,
    x2: 2030.34,
    y2: 6104.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6141.24,
    x2: 2030.34,
    y2: 6141.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6178.23,
    x2: 2030.34,
    y2: 6178.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6215.21,
    x2: 2030.34,
    y2: 6215.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6252.2,
    x2: 2030.34,
    y2: 6252.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6289.19,
    x2: 2030.34,
    y2: 6289.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6326.18,
    x2: 2030.34,
    y2: 6326.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6363.17,
    x2: 2030.34,
    y2: 6363.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6400.16,
    x2: 2030.34,
    y2: 6400.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6437.14,
    x2: 2030.34,
    y2: 6437.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6474.13,
    x2: 2030.34,
    y2: 6474.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6511.12,
    x2: 2030.34,
    y2: 6511.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6548.11,
    x2: 2030.34,
    y2: 6548.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6585.1,
    x2: 2030.34,
    y2: 6585.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6622.08,
    x2: 2030.34,
    y2: 6622.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6659.07,
    x2: 2030.34,
    y2: 6659.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 587.35,
    y1: 6696.06,
    x2: 2030.34,
    y2: 6696.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2150.61,
    y1: 5273.13,
    x2: 2150.61,
    y2: 5309.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3881.76,
    y1: 307.47,
    x2: 3697.95,
    y2: 307.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3881.76,
    y1: 344.05,
    x2: 3697.95,
    y2: 344.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3881.76,
    y1: 379.63,
    x2: 3697.95,
    y2: 379.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3881.76,
    y1: 416.2,
    x2: 3697.95,
    y2: 416.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3881.18,
    y1: 454.32,
    x2: 3697.37,
    y2: 454.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.08,
    y1: 2822.32,
    x2: 1932.15,
    y2: 2822.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.08,
    y1: 2859.88,
    x2: 1932.15,
    y2: 2859.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3805.11,
    y1: 2964.06,
    x2: 3805.11,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3768.12,
    y1: 2964.06,
    x2: 3768.12,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3731.13,
    y1: 2964.06,
    x2: 3731.13,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3693.69,
    y1: 2964.07,
    x2: 3693.69,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3656.7,
    y1: 2820.5,
    x2: 3656.7,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3619.71,
    y1: 2820.5,
    x2: 3619.71,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3582.72,
    y1: 2820.5,
    x2: 3582.72,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3545.73,
    y1: 2820.5,
    x2: 3545.73,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3508.74,
    y1: 2820.5,
    x2: 3508.75,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3471.76,
    y1: 2820.5,
    x2: 3471.76,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3434.77,
    y1: 2820.5,
    x2: 3434.77,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3397.78,
    y1: 2820.5,
    x2: 3397.78,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3360.79,
    y1: 2820.5,
    x2: 3360.79,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3323.8,
    y1: 2820.5,
    x2: 3323.81,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3286.82,
    y1: 2820.5,
    x2: 3286.82,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3249.83,
    y1: 2820.5,
    x2: 3249.83,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3212.84,
    y1: 2820.5,
    x2: 3212.84,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3175.85,
    y1: 2820.5,
    x2: 3175.85,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3138.86,
    y1: 2820.5,
    x2: 3138.87,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3101.87,
    y1: 2820.5,
    x2: 3101.88,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3064.89,
    y1: 2820.5,
    x2: 3064.89,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3027.9,
    y1: 2820.5,
    x2: 3027.9,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2990.91,
    y1: 2820.5,
    x2: 2990.91,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2953.92,
    y1: 2820.5,
    x2: 2953.92,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2916.93,
    y1: 2820.5,
    x2: 2916.94,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2879.95,
    y1: 2820.5,
    x2: 2879.95,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2842.96,
    y1: 2820.5,
    x2: 2842.96,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2805.97,
    y1: 2820.5,
    x2: 2805.97,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2768.98,
    y1: 2820.5,
    x2: 2768.98,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2731.99,
    y1: 2820.5,
    x2: 2732,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2695,
    y1: 2820.5,
    x2: 2695.01,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2658.02,
    y1: 2820.5,
    x2: 2658.02,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2621.03,
    y1: 2820.5,
    x2: 2621.03,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2584.04,
    y1: 2820.5,
    x2: 2584.04,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2547.05,
    y1: 2820.5,
    x2: 2547.05,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2510.06,
    y1: 2820.5,
    x2: 2510.07,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2473.08,
    y1: 2820.5,
    x2: 2473.08,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2436.09,
    y1: 2820.5,
    x2: 2436.09,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 2820.5,
    x2: 2399.1,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 2856.49,
    x2: 3692.89,
    y2: 2856.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 2893.48,
    x2: 3692.89,
    y2: 2893.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 2930.47,
    x2: 3692.89,
    y2: 2930.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 2967.45,
    x2: 3692.89,
    y2: 2967.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3004.44,
    x2: 3841.31,
    y2: 3004.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3041.43,
    x2: 3842.09,
    y2: 3041.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3078.42,
    x2: 3842.09,
    y2: 3078.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3115.41,
    x2: 3842.09,
    y2: 3115.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3152.39,
    x2: 3842.09,
    y2: 3152.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3189.38,
    x2: 3842.09,
    y2: 3189.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3226.37,
    x2: 3842.09,
    y2: 3226.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3263.36,
    x2: 3842.09,
    y2: 3263.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3300.35,
    x2: 3842.09,
    y2: 3300.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3337.34,
    x2: 3842.09,
    y2: 3337.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3374.32,
    x2: 3842.09,
    y2: 3374.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3411.31,
    x2: 3842.09,
    y2: 3411.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3448.3,
    x2: 3842.09,
    y2: 3448.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3485.29,
    x2: 3842.09,
    y2: 3485.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3522.28,
    x2: 3842.09,
    y2: 3522.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3559.26,
    x2: 3842.09,
    y2: 3559.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3596.25,
    x2: 3842.09,
    y2: 3596.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3633.24,
    x2: 3842.09,
    y2: 3633.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3670.23,
    x2: 3842.09,
    y2: 3670.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3707.22,
    x2: 3842.09,
    y2: 3707.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3744.21,
    x2: 3842.09,
    y2: 3744.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3781.19,
    x2: 3842.09,
    y2: 3781.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3818.18,
    x2: 3842.09,
    y2: 3818.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3855.17,
    x2: 3842.09,
    y2: 3855.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3892.16,
    x2: 3842.09,
    y2: 3892.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3929.15,
    x2: 3842.09,
    y2: 3929.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 3966.13,
    x2: 3842.09,
    y2: 3966.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4003.12,
    x2: 3842.09,
    y2: 4003.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4040.11,
    x2: 3842.09,
    y2: 4040.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4077.1,
    x2: 3842.09,
    y2: 4077.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4114.09,
    x2: 3842.09,
    y2: 4114.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4151.08,
    x2: 3842.09,
    y2: 4151.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4188.06,
    x2: 3842.09,
    y2: 4188.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4225.05,
    x2: 3842.09,
    y2: 4225.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4262.04,
    x2: 3842.09,
    y2: 4262.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4299.03,
    x2: 3842.09,
    y2: 4299.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4336.02,
    x2: 3842.09,
    y2: 4336.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4373,
    x2: 3842.09,
    y2: 4373
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4409.99,
    x2: 3842.09,
    y2: 4409.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4446.98,
    x2: 3805.11,
    y2: 4446.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4483.97,
    x2: 3805.11,
    y2: 4483.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4520.96,
    x2: 3805.11,
    y2: 4520.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4557.95,
    x2: 3805.11,
    y2: 4557.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4594.93,
    x2: 3805.11,
    y2: 4594.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2399.1,
    y1: 4631.92,
    x2: 3805.11,
    y2: 4631.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3780.48,
    y1: 2771.66,
    x2: 3780.48,
    y2: 2920.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3817.05,
    y1: 2771.66,
    x2: 3817.05,
    y2: 2920.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3852.63,
    y1: 2771.66,
    x2: 3852.63,
    y2: 2920.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3886.64,
    y1: 2807.21,
    x2: 3743.58,
    y2: 2807.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3886.64,
    y1: 2843.79,
    x2: 3743.58,
    y2: 2843.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3886.19,
    y1: 2881.91,
    x2: 3743.13,
    y2: 2881.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1891.72,
    y1: 5246.14,
    x2: 1891.72,
    y2: 5392.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1927.8,
    y1: 5246.14,
    x2: 1927.8,
    y2: 5392.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1964.89,
    y1: 5246.14,
    x2: 1964.89,
    y2: 5392.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2001.98,
    y1: 5246.14,
    x2: 2001.98,
    y2: 5392.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2076.77,
    y1: 5281.83,
    x2: 1856.36,
    y2: 5281.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2076.77,
    y1: 5318.79,
    x2: 1856.36,
    y2: 5318.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2076.77,
    y1: 5357.76,
    x2: 1856.36,
    y2: 5357.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2076.77,
    y1: 5394.72,
    x2: 2001.98,
    y2: 5394.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2040.06,
    y1: 5246.14,
    x2: 2040.06,
    y2: 5430.72
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsMobileVd);
export default __webpack_public_path__ + "static/media/results-mobile-vd.5f859e5790386ac719c86e82f49480a6.svg";
export { ForwardRef as ReactComponent };